module.exports = __webpack_public_path__ + "img/f861575d2a9af62680188725abef5638.png";